/**
* Created by Jaime Bonilla Venegas on 2017-06-23.
* Item model for each "Conceptos"
*/
import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import Trash from 'material-ui/svg-icons/action/delete';
import Block from 'material-ui/svg-icons/content/block';
import Guardar from 'material-ui/svg-icons/content/save';
import { EditableInline, EditableInlineV2 } from '../../../components/text';
import IconButton from 'material-ui/IconButton';
import Avatar from 'material-ui/Avatar';
import ListItem from 'material-ui/List/ListItem';
import DatePicker from 'material-ui/DatePicker';
import AutoComplete from 'material-ui/AutoComplete';
import { extractProperty } from '../../../common/helpers';
import moment from 'moment';
import {
    DropDownSearch,
    RemoteDropDownSearch,
    RemoteCheckboxGroup
} from '../../../components/data-containers';
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar';
import CloseIcon from 'material-ui/svg-icons/action/delete';
import Button from 'material-ui/RaisedButton';
import { TablesReports } from '../../../components/data-containers';
import {
    customers as customers
} from '../../../services';


const styles = {
    propContainer: {
        width: 200,
        overflow: 'hidden',
        margin: '20px auto 0',
    },
    propToggleHeader: {
        margin: '20px auto 10px',
    },
};

const filter = {
    customsHouse:'',
    customer: '',
    customerName: "",
    status: '',
    users: '',
    allcustomers: [],
};
const auxDates = {
  maxDate:'',
  minDate:'',
  minDateByCustomer:'',
  maxDateByCustomer:'',
  minDateByCustomHouse:'',
  maxDateByCustomHouse:'',
  minDateByStatus:'',
  maxDateByStatus:'',
  minDateByUser:'',
  maxDateByUser:'',
}

class Item extends Component {
    constructor(props){
      super(props);
      this.state = {
        fixedHeader: true,
        stripedRows: false,
        showRowHover: false,
        selectable: true,
        multiSelectable: true,
        enableSelectAll: false,
        deselectOnClickaway: true,
        showCheckboxes: true,
        height: '300px',
        open: false,
        ...filter,
        ...auxDates,
        open: false,
      };
    }

    componentDidMount(userInformation) {
        this._isMounted = true;
        customers.getCustomers({
        }).then(data => {
            if (this._isMounted) {
              this.updateValue('allcustomers', data.customers);
            }
        })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    updateValue = (path, value) => {
        this.setState({ [path]: value });
    };

    handleRequestClose = (event, reason) => {
      this.setState({ open: false });
    };

    render() {
        const { status, text, customsHouses, customsClearencesbyAduana, customsClearencesbyCustomer, customsClearencesbyStatus, customsClearencesbyUser, customers, statuses, usuarios, test, actions, open=true} = this.props;
        const { maxDate, minDate, customsHouse } = this.state;

        return (
            <div>
                <div>
                    <ul className="nav nav-tabs" style={{ marginTop: '15rem'}}>
                        <li className="active">
                            <a href="#1" data-toggle="tab">Reporte de Despachos por Cliente</a>
                        </li>
                        <li>
                            <a href="#2" data-toggle="tab">Reporte de Despacho por Aduana</a>
                        </li>
                        <li>
                            <a href="#3" data-toggle="tab">Reporte de Despachos por Estado</a>
                        </li>
                        <li>
                            <a href="#4" data-toggle="tab">Reporte de Operador</a>
                        </li>
                  </ul>
            <div className="tab-content reportes box-shadow padding-3">
                <div className="tab-pane active" id={1}>
                    <div className="row header-reports">
                        <div className="col-md-6">
                            <p className="text-bold text-color-light">Cliente</p>
                            <DropDownSearch
                            floatingLabelText="Cliente"
                                fullWidth
                                dataSource={extractProperty(customers, 'name')}
                                onNewRequest={(request, idx) => {
                                    const newValue = customers[idx].uuid;
                                    this.updateValue('customer', newValue);
                                }}
                            />
                            {/*<EditableInlineV2
                                type="remoteAutocomplete"
                                editViewActive={true}
                                value={this.state.customerName}
                                serviceName='customers'
                                entity='customers'
                                url='/customers/search/findTop10ByNameIgnoreCaseContaining'
                                projectionName='forListing'
                                notify={(value) => {
                                  const newValue = value.id.replace("/customer/","");
                                  this.updateValue('customer', newValue);
                                  this.updateValue('customerName', value.name);
                                }}
                            />*/}
                        </div>
                        <div className="col-md-6 no-paddings">
                        <div className="col-md-6">
                              <DatePicker
                                  formatDate={(date) => moment(date).format('DD-MM-YYYY')}
                                  autoOk
                                  floatingLabelFixed
                                  fullWidth
                                  floatingLabelText="De"
                                  onChange={(event, value) => {
                                    this.updateValue('minDate', value);
                                    this.updateValue('minDateByCustomer', moment(value).format('DD-MM-YYYY'))
                                  }}
                                  />
                                  </div>
                                  <div className="col-md-6">
                              <DatePicker
                                  formatDate={(date) => moment(date).format('DD-MM-YYYY')}
                                  autoOk
                                  floatingLabelFixed
                                  fullWidth
                                  floatingLabelText="Hasta"
                                  onChange={(event, value) => {
                                    this.updateValue('maxDate', value);
                                    this.updateValue('maxDateByCustomer', moment(value).format('DD-MM-YYYY'))
                                  }}
                                />
                                </div>
                        </div>
                        <div className="col-md-12 text-right">
                          <FlatButton
                            label="Buscar"
                            primary={true}
                            onClick={()=> {
                              if (this.state.customer != "" && this.state.minDateByCustomer != "" && this.state.maxDateByCustomer != "" ) {
                                actions.getInfoBy({auxButton: 'Customer', customer: this.state.customer, arrivalTimestamp: [this.state.minDateByCustomer+'ATS'+this.state.maxDateByCustomer]}, 'customsClearencesbyCustomer');
                              }else {
                                this.setState({ open: true });
                              }
                            }}
                          />
                          <FlatButton
                            label="Exportar XLS"
                            primary={true}
                            onClick={()=> {
                              if (this.state.customer != "" && this.state.minDateByCustomer != "" && this.state.maxDateByCustomer != "" ) {
                                actions.getCustomsClearence(this.state, 'PorCliente');
                              }else {
                                this.setState({ open: true });
                              }
                            }}
                          />
                        </div>
                    </div>
                    <hr/>
                    <TablesReports
                      info={customsClearencesbyCustomer}
                    />
                </div>
                <div className="tab-pane" id={2}>
                    <div className="row header-reports">
                        <div className="col-md-6">
                            <p className="text-bold text-color-light">Aduana</p>
                            <DropDownSearch
                                fullWidth
                                dataSource={extractProperty(customsHouses, 'name')}
                                onNewRequest={(request, idx) => {
                                    const newValue = customsHouses[idx].uuid;
                                    this.updateValue('customsHouse', newValue);
                                }}
                            />
                        </div>
                        <div className="col-md-6 no-paddings">
                        <div className="col-md-6">
                            <DatePicker
                                formatDate={(date) => moment(date).format('DD-MM-YYYY')}
                                autoOk
                                floatingLabelFixed
                                fullWidth
                                floatingLabelText="De"
                                onChange={(event, value) => {
                                  this.updateValue('minDate', value);
                                  this.updateValue('minDateByCustomHouse', moment(value).format('DD-MM-YYYY'))
                                }}
                                />
                                </div>
                                <div className="col-md-6">
                            <DatePicker
                                formatDate={(date) => moment(date).format('DD-MM-YYYY')}
                                autoOk
                                floatingLabelFixed
                                fullWidth
                                floatingLabelText="Hasta"
                                onChange={(event, value) => {
                                  this.updateValue('maxDate', value);
                                  this.updateValue('maxDateByCustomHouse', moment(value).format('DD-MM-YYYY'))
                                }}
                              />
                              </div>
                        </div>
                        <div className="col-md-12 text-right">
                          <FlatButton
                            label="Buscar"
                            primary={true}
                            onClick={()=> {
                              if (this.state.customsHouse != "" && this.state.minDateByCustomHouse != "" && this.state.maxDateByCustomHouse != "" ) {
                                actions.getInfoBy({auxButton: 'CustomsHouse', customsHouse: this.state.customsHouse, arrivalTimestamp: [this.state.minDateByCustomHouse+'ATS'+this.state.maxDateByCustomHouse]}, 'customsClearencesbyAduana');
                              }else {
                                this.setState({ open: true });
                              }
                            }}
                          />
                          <FlatButton
                            label="Exportar XLS"
                            primary={true}
                            onClick={()=> {
                              if (this.state.customsHouse != "" && this.state.minDateByCustomHouse != "" && this.state.maxDateByCustomHouse != "" ) {
                                actions.getCustomsClearence(this.state, 'PorAduana');
                              }else {
                                this.setState({ open: true });
                              }
                            }}
                        />
                        </div>
                    </div>
                    <hr/>
                    <TablesReports
                      info={customsClearencesbyAduana}
                    />
                </div>
                <div className="tab-pane" id={3}>
                    <div className="row header-reports">
                        <div className="col-md-6">
                            <p className="text-bold text-color-light">Estado</p>
                            <DropDownSearch
                                fullWidth
                                dataSource={extractProperty(statuses, 'name')}
                                onNewRequest={(request, idx) => {
                                    const newValue = statuses[idx].name;
                                    this.updateValue('status', newValue);
                                }}
                            />                        </div>
                        <div className="col-md-6 no-paddings">
                        <div className="col-md-6">
                          <DatePicker
                              formatDate={(date) => moment(date).format('DD-MM-YYYY')}
                              autoOk
                              floatingLabelFixed
                              fullWidth
                              floatingLabelText="De"
                              onChange={(event, value) => {
                                this.updateValue('minDate', value);
                                this.updateValue('minDateByStatus', moment(value).format('DD-MM-YYYY'))
                              }}
                              />
                              </div>
                              <div className="col-md-6">
                          <DatePicker
                              formatDate={(date) => moment(date).format('DD-MM-YYYY')}
                              autoOk
                              floatingLabelFixed
                              fullWidth
                              floatingLabelText="Hasta"
                              onChange={(event, value) => {
                                this.updateValue('maxDate', value);
                                this.updateValue('maxDateByStatus', moment(value).format('DD-MM-YYYY'))
                              }}
                            />
                            </div>
                        </div>
                        <div className="col-md-12 text-right">
                          <FlatButton
                            label="Buscar"
                            primary={true}
                            onClick={()=> {
                              if (this.state.status != "" && this.state.minDateByStatus != "" && this.state.maxDateByStatus != "" ) {
                                actions.getInfoBy({auxButton: 'Status', status: this.state.status, arrivalTimestamp: [this.state.minDateByStatus+'ATS'+this.state.maxDateByStatus]}, 'customsClearencesbyStatus');
                              }else {
                                this.setState({ open: true });
                              }
                            }}
                          />

                            <FlatButton
                              label="Exportar XLS"
                              primary={true}
                              onClick={()=> {
                                if (this.state.status != "" && this.state.minDateByStatus != "" && this.state.maxDateByStatus != "" ) {
                                  actions.getCustomsClearence(this.state, 'PorEstado');
                                }else {
                                  this.setState({ open: true });
                                }
                              }}
                            />
                        </div>
                    </div>
                    <hr/>
                    <TablesReports
                      info={customsClearencesbyStatus }
                    />
                </div>
                <div className="tab-pane" id={4}>
                    <div className="row header-reports">
                        <div className="col-md-6">
                            <p className="text-bold text-color-light">Usuario</p>
                            <DropDownSearch
                                fullWidth
                                dataSource={extractProperty(usuarios, 'name')}
                                onNewRequest={(request, idx) => {
                                    const newValue = usuarios[idx].uuid.replace('/user/','');
                                    this.updateValue('user', newValue);
                                }}
                            />
                        </div>
                        <div className="col-md-6 no-paddings">
                        <div className="col-md-6">
                            <DatePicker
                                formatDate={(date) => moment(date).format('DD-MM-YYYY')}
                                autoOk
                                floatingLabelFixed
                                fullWidth
                                floatingLabelText="De"
                                onChange={(event, value) => {
                                  this.updateValue('minDate', value);
                                  this.updateValue('minDateByUser', moment(value).format('DD-MM-YYYY'))
                                }}
                                />
                                </div>
                                <div className="col-md-6">
                            <DatePicker
                                formatDate={(date) => moment(date).format('DD-MM-YYYY')}
                                autoOk
                                floatingLabelFixed
                                fullWidth
                                floatingLabelText="Hasta"
                                onChange={(event, value) => {
                                  this.updateValue('maxDate', value);
                                  this.updateValue('maxDateByUser', moment(value).format('DD-MM-YYYY'))
                                }}
                              />
                              </div>
                        </div>
                        <div className="col-md-12 text-right">
                          <FlatButton
                            label="Buscar"
                            primary={true}
                            onClick={()=> {
                              if (this.state.user != "" && this.state.minDateByUser != "" && this.state.maxDateByUser != "" ) {
                                actions.getInfoBy({auxButton: 'User', user: this.state.user, startDate: this.state.minDateByUser, endDate: this.state.maxDateByUser }, 'customsClearencesbyUser');
                              }else {
                                this.setState({ open: true });
                              }
                            }}
                          />

                            <FlatButton
                              label="Exportar XLS"
                              primary={true}
                              onClick={()=> {
                                if (this.state.user != "" && this.state.minDateByUser != "" && this.state.maxDateByUser != "" ) {
                                  actions.getCustomsClearence(this.state, 'PorUsuario');
                                }else {
                                  this.setState({ open: true });
                                }
                              }}
                            />
                        </div>
                    </div>
                    <hr/>
                    <TablesReports
                      info={customsClearencesbyUser }
                    />
                </div>
            </div>
        </div>

        <Snackbar
          bodyStyle={{
              top: 0,
              bottom: 'auto',
              backgroundColor: '#ce3b3b',
              left: (window.innerWidth - 288) / 2,
              /*transform: this.props.errorMessage ?
                'translate3d(0, 0, 0)' :
                "translate3d(0, "+ -(window.innerHeight - 100) + "px , 0)"*/
          }}
          open={this.state.open}
          message="Por favor llena los campos para obtener el reporte"
          autoHideDuration={2000}
          onRequestClose={() => this.setState({ open: false })}
        />
    </div>
);
}
}

export default Item;



// WEBPACK FOOTER //
// ./containers/reportes/components/item.js